import events from './events'
import reservations from './reservations'
import ridingschool from './ridingschool'

const items = { events, reservations, ridingschool }

export default (type, defaults) => items[type](defaults)
